import { Component, OnInit, Directive, Input, ViewChild, ContentChildren, TemplateRef, ContentChild, Output, EventEmitter, HostListener, ElementRef, QueryList, SimpleChanges, OnChanges } from '@angular/core';
import { GridOptionsModel, PaginationsModel, FetchCriteriaModel, FilterService, GridSortService, ColumnDefinitionsModel, GridDataService } from '../custom-grid-extended/shared';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';


@Directive({selector: '[cellExtended]'})
export class CellExtended {
  @Input() id!: string;
}

@Component({
  selector: 'app-custom-grid-extended',
  providers: [FilterService, GridSortService, GridDataService],
  templateUrl: './custom-grid-extended.component.html',
  styleUrls: ['./custom-grid-extended.component.scss']
})
export class CustomGridExtendedComponent implements OnInit
 {

  startIndex: number = 0;
  searchPlaceHolder: string = 'Enter first or last name';
  ctnMask: boolean = false;
  imeiMask: boolean = false;
  searchDescriptions: string = '';
  gridProperties: GridOptionsModel;
  showBackLink: boolean;
  isGridValid: boolean;
  filteredColumns = [];
  gridData: any;
  filteredData: any;
  showLogs: boolean = false;
  //multipleSelectedItems = [];
  //singleSelectedItems = [];
  paginations: PaginationsModel;
  sortColumn: string = "";
  sortDirection: string = "";
  searchValue: string = "";
  showhigherpriorities: number = 0;
  allRowsSelected: boolean = false;
  maxPriority: number = 0;
  showTable: boolean;
  enableSearchLimit: boolean = false;
  searchLimit: number = 3;
  searchMessage: string = "";
  ctnNumbertoFormate: FormControl;
  maxLength: number;
  numericSearch: boolean;
  ariaLabel: string;
  sortAriaLabel: string;
  changeSortOrderAriaLabel: string;
  searchLabel: string;
  sortHeadAria: string;
  hideSortHeadRead: boolean;
  ctnSelect: boolean = true;
  imeiSelect: boolean = false;
  isDeviceInventoryUrl: boolean = false;
  isDeviceSubmissionUrl: boolean = false;
  isClicked: boolean = false;
  showCopiedMessage: boolean = false;
  clickedRowIndex: number | null = null;
  selectedRow: any;
  isCopied: boolean = false;

  @ViewChild('searchValue') searchFan;

  @Input() mainAriaLAbel :  any;
  searchByCtn: boolean = true;

  @Input() set filterValue(searchValue) {
    if(searchValue != undefined) {
      this.filter(searchValue);
    }
  } 

  @Input() transactionData: any;

  @Input() set gridOptions(options: GridOptionsModel) {
    if (options == undefined) {
      this.isGridValid = false;
      return;
    }
    this.isGridValid = true;
    this.gridProperties = options;
    this.paginations = options.Paginations;
    this.searchPlaceHolder = options.searchPlaceHolder === undefined ? this.searchPlaceHolder : options.searchPlaceHolder;
    this.ctnMask = options.ctnMask === undefined ? this.ctnMask : options.ctnMask;
    this.imeiMask = options.imeiMask === undefined ? this.imeiMask : options.imeiMask;
    this.searchDescriptions = options.searchDescriptions;
    this.showTable = options.showGrid;
    this.enableSearchLimit = options.enableSearchLimit;
    this.searchLimit = options.searchLimit;
    this.maxLength = options.maxLength;
    this.ariaLabel = options.ariaLabel?options.ariaLabel:this.mainAriaLAbel;
    if (options.searchType === 'number') {
      this.numericSearch = true;
    };
    this.gridProperties.columnDefinitions.forEach(r => {
      r['priority'] = r['priority'] === undefined ? 1 : r['priority'];
      if (this.maxPriority < r['priority']) {
        this.maxPriority = r['priority'];
      }
    });

    if (this.paginations.currentPage == 1) {
      this.startIndex = 0;
    }
    this.getApplicableFilterCols();
    if (this.gridProperties.multiSelect) {
      this.gridData = this.setDefault(options.gridData);
    }
    if (this.paginations.isServerSide) {
      this.gridData = options.gridData
    } else {
      this.setGridData(options.gridData);
    }
    this.checkAllRowsSelected();
  }

  @ContentChildren(TemplateRef) contentChildrenList: QueryList<TemplateRef<any>>;
  contentChildren: TemplateRef<any>[];
  @ContentChild('header',{read: false}) templateRef: TemplateRef<any>;
  
  @ViewChild('gridcontainer') gridcontainer;
  @Output() hrefLink: EventEmitter<any> = new EventEmitter<any>();
  @Output() checkboxSelections: EventEmitter<any> = new EventEmitter<any>();
  @Output() radioSelections: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSearch: EventEmitter<any> = new EventEmitter<any>();

  @Output() onDataChange: EventEmitter<any> = new EventEmitter<any>();
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setPriorityData();
  }


  @Output() gridEvent: EventEmitter<FetchCriteriaModel> = new EventEmitter<FetchCriteriaModel>();



  constructor(private el: ElementRef,
    private filterService: FilterService,
    private router : Router,
    private gridSortService: GridSortService) {
    this.ctnNumbertoFormate = new FormControl();   
  }
  // getData() {

  //   console.log('Service getData');
  //   this.gridService.fetchGridData(this.utilityService.getEnvConfig().mockGridDataUrl).
  //     subscribe(respobj => {
  //       console.log(respobj);
  //       if (respobj != null && respobj != undefined) {
  //         this.filteredData = this.filteredData.concat(respobj);
  //         this.totalRecords = this.filteredData.length;
  //       }
  //     }, error => {
  //       console.log(error);
  //     });
  // }

  linkAction(currentData, column) {
    currentData = Object.assign({}, currentData, { 'selectedColumn': column });
    this.hrefLink.emit(currentData);
  }
  ngOnInit() {
    this.setPriorityData();
    // if (!this.ariaLabel) {
    //   this.ariaLabel = 'Enter first or last name';
    // }
    this.searchByCtn = JSON.parse(sessionStorage.getItem('searchByCtn'));
      this.isDeviceInventoryUrl = this.router.url === '/deviceInventory';

      if(this.router.url === '/care/deviceSubmissionTracking') {
        this.isDeviceSubmissionUrl = true;
      }
  }

  ngAfterContentChecked(){
    document.querySelectorAll(".ctn-number").forEach((elment) => {
      elment['href'] = "javascript:void(0);";
    })
  }

  toggleRow(row: any): void {
    row.isCollapsed = !row.isCollapsed;
  }

  ngAfterContentInit() {
    this.contentChildren = this.contentChildrenList.toArray();
  }

  searchBy(value: any) {
    this.searchFan.nativeElement.value = "";
    if(value == "imei") {
      this.searchPlaceHolder = "Enter IMEI number";
      this.ctnMask = false;
      this.imeiMask = true;
      this.ctnSelect = false;
      this.imeiSelect = true;
      this.maxLength = 15;
      this.ariaLabel = "Enter IMEI number";
    }
    else {
      this.searchPlaceHolder = "Enter wireless number";
      this.ctnMask = true;
      this.imeiMask = false;
      this.ctnSelect = true;
      this.imeiSelect = false;
      this.maxLength = 12;
      this.ariaLabel = "Enter wireless number";
    }
  }

  onRowClick(index: number): void {
    this.clickedRowIndex = index;
  }

  copyTransactionLogs(row: any, event: MouseEvent): void {
    event.stopPropagation();
    this.transactionData.forEach(r => r.showCopiedMessage = false);
    row.showCopiedMessage = true;
    if (navigator.clipboard) {
      this.showCopiedMessage = true;
      setTimeout(() => {
        row.showCopiedMessage = false;
      }, 3000);
      const formattedLogs = JSON.stringify(this.transactionData, null, 2);
      navigator.clipboard.writeText(formattedLogs)
        .then(() => {
          console.log('Transaction logs copied to clipboard in formatted structure!');
        })
        .catch(err => {
          console.error('Failed to copy transaction logs: ', err);
        });
    }
  }

  onPageChange(startIndex) {
    this.startIndex = startIndex;
    this.paginations.currentPage = (startIndex / this.paginations.recordsPerPage) + 1;
    if (this.paginations.isServerSide) {
      this.getServerData();
    }
    else {
      this.getPageData(this.paginations.currentPage);
    }
    this.checkAllRowsSelected();
    // const focusableEls = this.el.nativeElement.getElementsByTagName('table')[0].querySelectorAll('a[href], area[href],' +
    //   ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
    // if (focusableEls.length) {
    //   focusableEls[0].focus();
    // }
    const focusableEls = this.el.nativeElement.querySelectorAll('#totalCount');
    if (focusableEls.length) {
      setTimeout(() => { focusableEls[0].focus(); });
    }
  }



  setGridData(data: any) {
    this.filteredData = data;
    this.getPageData(this.paginations.currentPage);
  }

  onPlusIconClick(row: any): void {
    this.isClicked = true;
    this.gridData.forEach(r => {
      if (r !== row) {
        r.accordion = false;
      }
    });
    row.accordion = !row.accordion;
    if(row.accordion){
      this.gridEvent.emit(row._id);
    }
  }

  selectRow(index: number) {
    this.selectedRow = this.selectedRow === index ? null : index;
  }


  getApplicableFilterCols() {
    this.filteredColumns = [];
    if(this.imeiSelect && !this.ctnSelect) {
      this.filteredColumns = [];
      this.filteredColumns.push("imei");
    }
    else if(this.ctnSelect && !this.imeiSelect) {
      this.filteredColumns = [];
      this.filteredColumns.push("ctnNumber");
    }
    console.log(this.filteredColumns);
    // if (this.gridProperties.enableFiltering) {
    //   for (let cols of this.gridProperties.columnDefinitions) {
    //     if (cols.enableFilter) {
          // this.filteredColumns.push(cols.field);
          // this.filteredColumns = [];
          // if(this.imeiSelect && !this.ctnSelect) {
          //   this.filteredColumns.push("imei");
          // }
          // else if(this.ctnSelect && !this.imeiSelect) {
          //   this.filteredColumns.push("ctnNumber");
          // }
          // console.log(this.filteredColumns);
          // if(cols.secondaryField) {
          //   this.filteredColumns.push(cols.secondaryField);
          // }
    //     }
    //   }
    // }
  }

  getPageData(pageNo: number) {

    let endIndex: number = 0;
    this.paginations.currentPage = pageNo - 1;
    endIndex = (this.startIndex + this.paginations.recordsPerPage);
    let data = this.filteredData;
    this.gridData = data.slice(this.startIndex, endIndex);
    // if (endIndex + (this.paginations.recordsPerPage * 2) > this.totalRecords) {
    //   this.getData();
    // }

    //for server side pagination : need to pass start-index & limit
    // bind the data directly to gridData


  }

  singleSelectionChanges(ctrl) {
    this.radioSelections.emit(ctrl);
    // this.singleSelectedItems = [];
    // this.singleSelectedItems.push(ctrl);
  }

  selectionChanges(ctrl, event) {

    ctrl = Object.assign({}, ctrl, { 'checkedStatus': event.target.checked });

    this.checkboxSelections.emit(ctrl);

    // if (event.target.checked) {
    //   this.multipleSelectedItems.push(ctrl);
    // }

    // else {
    //   if (this.multipleSelectedItems.find(x => x == ctrl)) {
    //     this.multipleSelectedItems.splice(this.multipleSelectedItems.indexOf(ctrl), 1)
    //   }
    // }
  }
  
  filter(searchValue: string, clearSearch?: boolean, linkType?: string) {
    let filteredData: any;
    searchValue = searchValue.trim();
    if (this.enableSearchLimit &&
      (searchValue.length > 0 && searchValue.length < this.searchLimit)) {
      this.searchMessage = "Enter atleast " + this.searchLimit + " characters to search"
      this.searchFan.nativeElement.focus();
      return;
    }

    if (this.enableSearchLimit && searchValue.toString().substring(0, 3).indexOf(' ') >= 0) {
      this.searchMessage = 'Enter valid characters to search';
      this.searchFan.nativeElement.focus();
      return;
    }

    this.searchMessage = "";
    if (this.ctnMask) {
      searchValue = searchValue.split('.').join('');
    }
    else {
      searchValue = searchValue;
    }
    this.startIndex = 0;
    this.searchValue = searchValue;
    this.paginations.currentPage = 1;
    this.filteredColumns = [];
      if(this.ctnSelect && !this.imeiSelect) {
        this.filteredColumns.push("ctnNumber");
      }
      else if(!this.ctnSelect && this.imeiSelect) {
        this.filteredColumns.push("imei");
      }
    if (this.paginations.isServerSide) {
      this.getServerData();
      this.showBackLink = true;
    } else {
      console.log(this.filteredColumns);
      filteredData = this.filterService.getFilteredData(
        this.gridProperties.gridData, searchValue, this.filteredColumns);
      this.paginations.totalRecords = filteredData.length;
      this.setGridData(filteredData);
      this.showBackLink = true;
    }
    if (clearSearch || !searchValue) {
      this.searchFan.nativeElement.value = '';
      this.showBackLink = false;
    } else {
      this.showBackLink = true;
    }
    this.checkAllRowsSelected();
    const searchCleared = clearSearch || !searchValue;
    if (!this.gridProperties.showGrid) {
      this.showTable = searchCleared ? false : true;
    }
    if (linkType === 'viewAllLink' && this.gridProperties.showGrid === false) {
      this.showTable = true;
      this.gridProperties.showGrid = true;
    }
    this.onSearch.emit({ 'search': searchCleared, 'results': filteredData });
    //window.dispatchEvent(new Event('resize'));
  }

  getServerData() {

    let fetchCriteria: FetchCriteriaModel = new FetchCriteriaModel();

    fetchCriteria.limit = this.paginations.recordsPerPage;
    fetchCriteria.offset = this.startIndex;

    if (this.sortColumn.length > 0) {
      fetchCriteria.sortField = this.sortColumn;
    }

    if (this.sortDirection.length > 0) {
      fetchCriteria.sortDir = this.sortDirection.toUpperCase();
    }

    if (this.searchValue.length > 0) {
      fetchCriteria.searchValue = this.searchValue;
    }

    if(this.filteredColumns.length > 0) {
      fetchCriteria.filteredCols = this.filteredColumns[0];
    }

    this.gridEvent.emit(fetchCriteria);


    // let fetchCriteria: FetchCriteriaModel = new FetchCriteriaModel();

    // fetchCriteria.class = "API::SepPagingLoadConfig";
    // fetchCriteria.limit = this.paginations.recordsPerPage;
    // fetchCriteria.offset = this.startIndex;
    // fetchCriteria.sortDir = this.sortDirection.toUpperCase();
    // fetchCriteria.sortField = this.sortColumn;

    // this.gridProperties.gridFetch.fetchCriteria = fetchCriteria;

    // if (this.searchValue.length > 0) {
    //   this.gridProperties.gridFetch.searchValue = this.searchValue;
    // }

    // console.log('Service getData');
    // this.gridService.fetchGridServiceData(this.gridProperties.dataUrl, this.gridProperties.gridFetch).
    //   subscribe(respobj => {
    //     console.log(respobj);
    //     if (respobj != null && respobj != undefined) {
    //       if (isPageChanges) {
    //         this.gridData = respobj;
    //       }
    //       else {
    //         this.setGridData(respobj);
    //         this.paginations.totalRecords = respobj.length;
    //       }
    //     }
    //   }, error => {
    //     console.log(error);
    //   });
  }

  // handleSort( col: ColumnDefinitionsModel){
  //   this.sortHeadAria = col.sortDirection === 'Asc'? 'Sort descending - '+col.caption : 'Sort ascending - '+col.caption;
  //   console.log( this.sortHeadAria );
  //   return this.sortHeadAria;
  // }

  handleHeadingFocus( ){
    this.ariaLabel = this.gridProperties.ariaLabel? this.gridProperties.ariaLabel: this.mainAriaLAbel;
  }

  handleHeadingBlur( ){
    this.ariaLabel = null;
  }

  handleSortBlur(  ){ 
      this.hideSortHeadRead = true;
  }

  handleSortFocus(  ){
      this.hideSortHeadRead = false;
  }


  sort(col: ColumnDefinitionsModel) {
    this.gridProperties.columnDefinitions.forEach((column: ColumnDefinitionsModel) => {
      if (column.field !== col.field) {
        column.sortDirection = 'Asc';
        if (column.sortDirection === 'Desc') {
          let sortedData = this.gridSortService.getSortedData(
            this.filteredData, column.field, 'Asc');
          this.setGridData(sortedData);
        }
      }
    }),
    this.sortColumn = col.field;
    this.sortDirection = (!!col.sortDirection && col.sortDirection !== 'Default') ? col.sortDirection : 'Desc';
    this.paginations.currentPage = 1;
    this.startIndex = 0;
    this.sortDirection = (this.sortDirection.toLowerCase() == 'asc') ? 'Desc' : 'Asc';
    if (this.paginations.isServerSide) {
      this.getServerData();
    }
    else {
      let sortedData = this.gridSortService.getSortedData(
        this.filteredData, this.sortColumn, this.sortDirection);
      //this.paginations.currentPage = this.paginations.currentPage + 1;
      this.setGridData(sortedData);
    }

    col.sortDirection = this.sortDirection;
    this.checkAllRowsSelected();
  }

  multiSelectAction(event) {
    const checkStatus = event.target.checked;
    this.filteredData.forEach(r => {
      if (!this.gridProperties.disableRow ||
      (this.gridProperties.disableRow && this.gridProperties.disableRowConditionInverse &&
      r[this.gridProperties.disableRowCondition.field] === this.gridProperties.disableRowCondition.value) ||
      (this.gridProperties.disableRow && !this.gridProperties.disableRowConditionInverse &&
      r[this.gridProperties.disableRowCondition.field] !== this.gridProperties.disableRowCondition.value)
      ) {
        r['selected'] = checkStatus;
      }
    });
    this.onDataChange.emit({ data: this.gridProperties.gridData, griddata: this.filteredData, type: 'multiselect' });
    this.checkAllRowsSelected();
  }

  setDefault(filteredData) {
    return filteredData.forEach(r => r['selected'] = r['selected'] === undefined ? false : r['selected']);
  }

  checkAllRowsSelected() {
    const selectedRow = this.gridData.filter(item => item.selected === true);
    const activeRow = this.gridData.filter(item => !this.gridProperties.disableRow ||
    (this.gridProperties.disableRow && this.gridProperties.disableRowConditionInverse &&
      item[this.gridProperties.disableRowCondition.field] === this.gridProperties.disableRowCondition.value) ||
      (this.gridProperties.disableRow && !this.gridProperties.disableRowConditionInverse &&
      item[this.gridProperties.disableRowCondition.field] !== this.gridProperties.disableRowCondition.value));
    this.allRowsSelected = activeRow.length === selectedRow.length;
  }

  singleSelectAction(col: ColumnDefinitionsModel, event) {
    const checkStatus = event.target.checked;
    col['selected'] = checkStatus;
    this.onDataChange.emit({ data: col, griddata: this.filteredData, type: 'singleselect' });
    this.checkAllRowsSelected();
  }

  setPriorityData() {
    if (window.innerWidth < 767) {
      this.showhigherpriorities = 2;
    }
    else if (window.innerWidth < 1000) {
      this.showhigherpriorities = 4;
    }
    else {
      this.showhigherpriorities = 6;
    }
  }

  ngDoCheck() {
    if(this.imeiSelect === true && this.ctnSelect === false) {
      this.ctnMask = false;
      this.imeiMask = true;
      this.maxLength = 15;
      this.searchPlaceHolder = "Enter IMEI number";
    }
    else if(!this.imeiSelect && this.ctnSelect) {
      this.ctnMask = true;
      this.imeiMask = false;
      this.maxLength = 12;
      this.searchPlaceHolder = "Enter Wireless number";
    }
  }


}
